// extracted by mini-css-extract-plugin
module.exports = {"productItems":"ProductList_productItems__1OwZX","productList":"ProductList_productList__1KGeZ","filters":"ProductList_filters__1M1IE"};